import { render, staticRenderFns } from "./myScrollBorder.vue?vue&type=template&id=3c42143e&"
import script from "./myScrollBorder.vue?vue&type=script&lang=js&"
export * from "./myScrollBorder.vue?vue&type=script&lang=js&"
import style0 from "./myScrollBorder.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports